import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import { queryIssuedDet, queryIssuedCheckDet } from '@/api/notice/documentApi.js';
import { queryPickOrg } from '@/api/commonApi.js';
export default {
  data: function data() {
    var columnOne = [{
      title: '成员姓名',
      dataIndex: 'userName',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '成员电话',
      dataIndex: 'phoneNumber',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '阅读状态',
      dataIndex: 'viewStatus',
      align: 'center',
      width: 100,
      scopedSlots: {
        customRender: 'viewStatus'
      }
    }, {
      title: '查阅时间',
      dataIndex: 'viewTime',
      ellipsis: true,
      align: 'center',
      width: 150
    }];
    var columnTwo = [{
      title: '成员姓名',
      dataIndex: 'userName',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '成员电话',
      dataIndex: 'phoneNumber',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '组织名称',
      dataIndex: 'organName',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '阅读状态',
      dataIndex: 'viewStatus',
      align: 'center',
      width: 100,
      scopedSlots: {
        customRender: 'viewStatus'
      }
    }, {
      title: '查阅时间',
      dataIndex: 'viewTime',
      ellipsis: true,
      align: 'center',
      width: 150
    }];
    var columnThree = [{
      title: '成员姓名',
      dataIndex: 'userName',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '成员电话',
      dataIndex: 'phoneNumber',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '岗位名称',
      dataIndex: 'postName',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '阅读状态',
      dataIndex: 'viewStatus',
      align: 'center',
      width: 100,
      scopedSlots: {
        customRender: 'viewStatus'
      }
    }, {
      title: '查阅时间',
      dataIndex: 'viewTime',
      ellipsis: true,
      align: 'center',
      width: 150
    }];
    var columnList = {
      1: columnOne,
      2: columnThree,
      3: columnTwo
    };
    var columnsDetail = [{
      title: '分发人姓名',
      dataIndex: 'userName',
      align: 'center',
      width: 100
    }, {
      title: '组织名称',
      dataIndex: 'organName',
      align: 'center',
      width: 100
    }, {
      title: '岗位名称',
      dataIndex: 'postName',
      align: 'center',
      width: 100
    }, {
      title: '分发范围',
      dataIndex: 'jsonDataObj',
      align: 'left',
      width: 200,
      scopedSlots: {
        customRender: 'jsonDataSlots'
      }
    }, {
      title: '分发时间',
      dataIndex: 'issuedTime',
      ellipsis: true,
      align: 'center',
      width: 120
    }, {
      title: '文件名称',
      dataIndex: 'fileName',
      ellipsis: true,
      align: 'center',
      width: 100
    }];
    return {
      columnsDetail: columnsDetail,
      loading: false,
      expand: false,
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 18
      },
      readData: {},
      data: [],
      referTypeId: 1,
      cateId: [0],
      referType: [{
        cateId: 1,
        cateName: '查阅情况-按人员'
      }, {
        cateId: 2,
        cateName: '查阅情况-按岗位'
      }, {
        cateId: 3,
        cateName: '查阅情况-按组织'
      }],
      columnList: columnList,
      where: {
        mobile: '',
        queryStr: '',
        docId: this.$route.query.docId,
        type: 1 // 查询情况类型(1个人，2岗位,3组织)
      },
      pagination: this.$hdk.page(),
      loadingDetail: false,
      dataDetail: []
    };
  },
  created: function created() {
    this.fetchDetail();
    this.fetch();
  },
  methods: {
    /**
     * 查阅类型切换
     */
    menuClick: function menuClick(row) {
      var $route = this.$route;
      this.referTypeId = row.cateId;
      // 切换数据置空
      this.where = {
        mobile: '',
        query: '',
        docId: $route.query.docId,
        type: row.cateId
      };
      this.fetch({
        current: 1,
        pageSize: 10
      });
    },
    /**
     * 查询分发详情
     */
    fetchDetail: function fetchDetail(options) {
      var _this = this;
      var $route = this.$route;
      queryIssuedDet({
        docId: $route.query.docId
      }).then(function (res) {
        _this.dataDetail = res.data.data;
      });
    },
    /**
     * 查询分发查阅情况
     */
    fetch: function fetch(options) {
      var _this2 = this;
      var pagination = this.pagination,
        where = this.where,
        pager = _.assign({}, pagination, options);
      this.loading = true;
      if (!pager.where) {
        pager.where = where;
      }

      // 根据查阅类型查询相关类型
      queryIssuedCheckDet(pager.current, pager.pageSize, pager.where).then(function (res) {
        if (res.status === 200) {
          _this2.readData = res.data;
          _this2.data = res.data.result.rows;
          _.assign(pagination, {
            total: res.data.result.total,
            current: pager.current,
            pageSize: pager.pageSize
          });
          _.assign(where, pager.where);
        }
      }).finally(function () {
        _this2.loading = false;
      });
    },
    /*
     * 表格改变事件
     */
    onChange: function onChange(pagination) {
      this.fetch({
        current: pagination.current,
        pageSize: pagination.pageSize,
        where: this.where
      });
    },
    /**
     * 返回列表页
     */
    goBack: function goBack() {
      this.$router.push({
        path: '/docNotice/doc/put'
      });
    }
  },
  computed: {
    columns: function columns() {
      return this.columnList[this.referTypeId];
    }
  }
};